// Dependencies
import { FC } from "react";
import { useSnackbar } from "notistack";
import { useMutation, useQueryClient } from "react-query";

// Components
import { MenuItem, Typography } from "@mui/material";

// Icons
import { ReactComponent as RemoveIcon } from "~/assets/icons/ban-solid.svg";

// Apis
import { unShareWallet } from "~/services/wallet";

// Types
import { TQueryError } from "~/types";
import { QUERY_KEY, USER_ROLE } from "~/enums";

// Styles
import {
  StyledRemoveIcon,
  StyledOtherUserName,
  StyledOtherUserInfo,
  StyledOtherUserWapper,
  StyledOtherUserAvatar,
  StyledOtherUserSelect,
  StyledOtherUserInfoName,
} from "./WalletAddMember.styled";

interface OtherUserSelectProps {
  walletId: string;
  memberName: string;
}

const userRoleList = USER_ROLE.map((role: string) => (
  <MenuItem value={role}>{role}</MenuItem>
));

const OtherUserSelect: FC<OtherUserSelectProps> = ({
  walletId,
  memberName,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  const UnshareWalletMutation = useMutation({
    mutationFn: unShareWallet,
    onSuccess() {
      enqueueSnackbar("Unshare Wallet success!", { variant: "success" });
      queryClient.invalidateQueries(QUERY_KEY.WALLET.WALLET_INFO);
    },
    onError(error: TQueryError) {
      enqueueSnackbar(error.message, { variant: "error" });
    },
  });

  // methods
  const handleUnshareWallet = () => {
    UnshareWalletMutation.mutate({
      unsharedUsername: memberName,
      walletInforID: walletId,
    });
  };
  return (
    <StyledOtherUserWapper>
      <StyledOtherUserInfo>
        <StyledOtherUserAvatar></StyledOtherUserAvatar>
        <StyledOtherUserInfoName>
          <StyledOtherUserName>{memberName}</StyledOtherUserName>
          <Typography variant={"h5"}>chinhnd1096@gmail.com</Typography>
        </StyledOtherUserInfoName>
      </StyledOtherUserInfo>
      <StyledOtherUserSelect defaultValue={"Member"}>
        {userRoleList}
      </StyledOtherUserSelect>
      <StyledRemoveIcon onClick={handleUnshareWallet}>
        <RemoveIcon />
      </StyledRemoveIcon>
    </StyledOtherUserWapper>
  );
};

export default OtherUserSelect;
